import { Navigate } from 'react-router';
import { ROUTER_PATH } from '@constants/routerItems.constant';
import { useAuth } from '@core/hooks/useAuth';
import type { FC, PropsWithChildren } from 'react';

const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return !isAuthenticated ? <Navigate to={ROUTER_PATH.login} replace /> : children;
};
export default ProtectedRoute;
